<template>
    <div class="login-page">
        <div class="login-box rounded welcome-container">
            <h2>Nieuw wachtwoord instellen</h2>
            <img src="@/assets/logo_horizontal.png" alt="Logo" width="200" />
            <p class="instructions">Kies een nieuw wachtwoord om verder te gaan:</p>
            <InputView v-model="newPassword" hint="Nieuw wachtwoord" :uppercase="false" type="password" />
            <InputView v-model="confirmPassword" hint="Bevestig wachtwoord" :uppercase="false" type="password" />
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <ButtonView text="Opslaan" @click="submit" :done="submitting" />
        </div>
    </div>
</template>

<script>
import ButtonView from '@/components/controlpanel/ButtonView.vue'
import InputView from '@/components/controlpanel/InputView.vue'
import { mapActions, mapState } from 'vuex'
import api from '@/repository/api.js'

export default {
    name: 'SetPasswordView',
    data() {
        return {
            newPassword: '',
            confirmPassword: '',
            errorMessage: '',
            submitting: false,
        };
    },
    computed: {
        ...mapState(['sessionToken', 'role'])
    },
    mounted() {
        if (!this.sessionToken) {
            this.$router.push('/login');
        }
    },
    methods: {
        ...mapActions(['clearRequiresReset']),
        async submit() {
            if (this.submitting) {
                return;
            }
            this.errorMessage = '';

            if (this.newPassword.length < 8) {
                this.errorMessage = 'Wachtwoord moet minimaal 8 tekens lang zijn.';
                return;
            }
            if (this.newPassword !== this.confirmPassword) {
                this.errorMessage = 'Wachtwoorden komen niet overeen.';
                return;
            }

            this.submitting = true;
            try {
                await api.setPassword(this.sessionToken, this.newPassword);
                await this.clearRequiresReset();
                this.$router.push('/admin');
            } catch (error) {
                this.errorMessage = error.response?.data?.message || error.message || 'Fout bij opslaan van wachtwoord.';
            } finally {
                this.submitting = false;
            }
        }
    },
    components: { ButtonView, InputView }
}
</script>

<style scoped>
.login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: white;
}

h2 {
    font: 700 2.2rem Roboto;
    color: var(--color-primary);
    text-align: center;
}

.alert {
    border-radius: 1rem;
}

.instructions {
    margin-top: 0.625rem;
    font: 700 1.4rem Roboto;
    color: var(--color-primary);
    text-align: center;
}

.welcome-container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    justify-content: flex-start;
    max-width: 33.25rem;
    padding: 3.25rem 5.5625rem 5.625rem;
    background: #f0f4ff;
    border: 0.09375rem solid var(--color-primary);
    border-radius: 0.8125rem;
    box-shadow: 0rem 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
}
</style>
